export enum StreamType {
  Standard = 'std',
  Accelerated = 'acc',
  Holiday = 'hol',
}
